import { useRef, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, type IDropdownItem } from 'shared/ui'
import { ChatbotActionType, type IChatbotActionType } from 'entities/Chatbot'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type ChatbotAction } from 'pages/chatbot/store/chatbotActionStore'
import { ActionsDropdown } from 'pages/chatbot/ui/ActionsDropdown/ActionsDropdown'
import styles from './styles.module.scss'

export interface IChatbotActionAddProps {
  actions: ChatbotAction
}

const ACTION_ITEMS: IDropdownItem[] = [
  {
    id: ChatbotActionType.AddTag,
    label: 'Add tag',
    iconL: 'tag',
  },
  {
    id: ChatbotActionType.RemoveTag,
    label: 'Remove tag',
    iconL: 'tag',
  },
  {
    id: ChatbotActionType.SendMessage,
    label: 'Send message',
    iconL: 'messageTextCircle02',
  },
  {
    id: ChatbotActionType.ContactNote,
    label: 'Add contact note',
    iconL: 'edit',
  },
]

export const ChatbotActionAdd = observer(({ actions }: IChatbotActionAddProps) => {
  const entities = useEntitiesContext()
  const ref = useRef<HTMLButtonElement | null>(null)
  const [dropdownWidth, setDropdownWidth] = useState<number | undefined>()

  const handleAddAction = (type: IChatbotActionType) => actions.createAction(type, entities)

  const handleToggleDropdown = () => {
    setDropdownWidth(ref.current?.getBoundingClientRect().width)
  }

  return (
    <div>
      <ActionsDropdown
        dropdownWidth={dropdownWidth}
        handleToggleDropdown={handleToggleDropdown}
        handleAddAction={handleAddAction}
        items={ACTION_ITEMS}
        groupTitle='Action'
        triggerComponent={() => (
          <Button
            className={styles.actionCardsControl}
            icon='add'
            text={'Add action'}
            contained={'secondary'}
            size={'medium'}
            ref={ref}
          />
        )}
      />
    </div>
  )
})
